module.exports = __webpack_public_path__ + "static/media/mobile-crown-dot.f275c59b.svg";